import { MinusOutlined, PlusOutlined } from '@otp/icons';
import styles from './index.module.css';
import clsx from 'clsx';

export enum ActionType {
  Add = 'add',
  Remove = 'remove',
}

type ActionsColumnProps = {
  onChange: () => void;
  action: ActionType;
};

export const ActionsColumn = ({ onChange, action }: ActionsColumnProps) => {
  return (
    <div onClick={(e) => e.stopPropagation()} className="flex justify-center">
      <div
        className={clsx(
          'cursor-pointer border border-solid border-grey-400 rounded-md p-1',
          styles.actionIcon,
        )}
        onClick={onChange}
      >
        {action === ActionType.Add ? <PlusOutlined /> : <MinusOutlined />}
      </div>
    </div>
  );
};
